module.exports = __webpack_public_path__ + "static/media/moon-rain.3048732c.svg";